import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=af1106ca&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "./Product.vue?vue&type=style&index=0&id=af1106ca&prod&lang=sass"
import style1 from "./Product.vue?vue&type=style&index=1&id=af1106ca&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1106ca",
  null
  
)

export default component.exports